import { Component } from "react";

import { boolToText } from "utilities/helpers";

import MultiFactorAuthStatusDisplay, {
    type IMultiFactorAuthStatusDisplayProps,
} from "commonComponents/utilities/MultiFactorAuthStatusDisplay/MultiFactorAuthStatusDisplay";

export default class MultiFactorAuthUserStatus extends Component<IMultiFactorAuthStatusDisplayProps> {
    private getAdditionalInfo = () => {
        const { isMfaEnabled } = this.props;
        return (
            <>
                Multi-factor authentication is turned <b>{boolToText(isMfaEnabled, "on", "off")}</b>{" "}
                for this user.
            </>
        );
    };
    render() {
        return (
            <MultiFactorAuthStatusDisplay
                isMfaEnabled={this.props.isMfaEnabled}
                className="padding-top-md"
                renderAdditionalInfo={this.getAdditionalInfo}
            />
        );
    }
}
